<template>
  <header class="d-print-none">
    <v-row class="mb-0">
      <v-col class="logo-container mt-2" cols="3" sm="2" md="1">
        <img :src="ncaaSmallLogo" alt="NCAA" />
      </v-col>
      <v-col class="mt-2 pt-6" cols="8" sm="6">
        <div class="appTitle">{{ appWideStore.applicationName }}</div>
      </v-col>
      <v-spacer class="hidden-sm-and-down" />
      <v-col
        v-if="userStore.isLoggedIn"
        class="text-md-right hidden-sm-and-down"
        cols="8"
        sm="3"
      >
        <div class="userName">{{ userStore.user.name }}</div>
        <div v-if="userStore.user.orgName" class="instName">
          {{ userStore.user.orgName }}
        </div>
        <div class="userLinks mr-n2">
          <v-btn-toggle dense borderless v-if="userStore.isNcaaAppAdmin">
            <v-btn small text :to="{ name: 'userList' }"> Login As </v-btn>
          </v-btn-toggle>
          <v-btn-toggle dense borderless>
            <v-btn small text :to="{ name: 'logout' }"> Log Out </v-btn>
          </v-btn-toggle>
        </div>
      </v-col>
      <v-col
        v-if="userStore.isLoggedIn"
        align-self="center"
        sm="1"
        class="institutionLogo hidden-sm-and-down"
        :class="{
          'member-logo': userStore.isConference || userStore.isInstitution,
          'staff-logo': userStore.isStaff,
        }"
      >
        <img
          :src="userStore.isStaff ? ncaaSmallLogo : userStore.user.orgLogoUrl"
          alt="Logo"
        />
      </v-col>
      <v-col v-if="!userStore.isLoggedIn" class="userLinks text-right">
        <v-btn-toggle dense borderless>
          <v-btn small text :to="{ name: 'login' }"> Login </v-btn>
        </v-btn-toggle>
      </v-col>
    </v-row>
  </header>
</template>

<script>
import { useUserStore } from "../../store/user";
import { useAppWideStore } from "../../store/appWide";
export default {
  name: "Header",
  setup() {
    const userStore = useUserStore();
    const appWideStore = useAppWideStore();
    const ncaaSmallLogo =
      "https://web2.ncaa.org/ncaa_style/img/All_Logos/sm/NCAA_logo_sm.png";
    return {
      userStore,
      appWideStore,
      ncaaSmallLogo,
    };
  },
};
</script>

<style scoped>
.member-logo {
  margin-top: -2em;
}
.staff-logo {
  margin-bottom: 2em;
}
.userLinks a {
  text-decoration: none;
}
</style>
